import { api } from './authService';

export interface UserRequest {
  id: string;
  type: 'account-upgrade';
  status: 'pending' | 'approved' | 'declined';
  supporting_data: {
    utility_bill_url: string;
  };
  created: number;
}

export interface UserRequestsResponse {
  user_requests: UserRequest[];
  next_cursor?: string;
}

export interface UserRequestParams {
  status?: string;
  user_id?: string;
  next_cursor?: string;
}

// Get all user requests
export const getUserRequests = async (params: UserRequestParams = {}): Promise<UserRequestsResponse> => {
  try {
    const searchParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, value as string);
      }
    });

    const response = await api.get(`/admin/user-requests?${searchParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user requests:', error);
    throw error;
  }
};

// Get specific user request by ID
export const getUserRequestById = async (id: string): Promise<UserRequest> => {
  try {
    const response = await api.get(`/admin/user-requests/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user request:', error);
    throw error;
  }
};

// Approve or decline user request
export const updateUserRequestStatus = async (
  id: string, 
  action: 'approve' | 'decline', 
  adminComment?: string
): Promise<UserRequest> => {
  try {
    const requestBody: any = { action };
    if (action === 'decline' && adminComment) {
      requestBody.admin_comment = adminComment;
    }

    const response = await api.patch(`/admin/user-requests/${id}`, requestBody);
    return response.data;
  } catch (error) {
    console.error('Error updating user request status:', error);
    throw error;
  }
};
